import { render, staticRenderFns } from "./HomeLiquor.vue?vue&type=template&id=ede648da&scoped=true&"
import script from "./HomeLiquor.vue?vue&type=script&lang=js&"
export * from "./HomeLiquor.vue?vue&type=script&lang=js&"
import style0 from "./HomeLiquor.vue?vue&type=style&index=0&id=ede648da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede648da",
  null
  
)

export default component.exports